import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getSignUps : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/graphics/sign-ups', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getprogramProgressCompletion : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/graphics/'+data.id+'/program-progress-completion', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getMonthsToGo : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/graphics/'+data.id+'/months-to-go', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	getHoursLearned : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/graphics/'+data.id+'/hours-learned', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/GraphicModule.js